import { render, staticRenderFns } from "./MobileSubscriptions.vue?vue&type=template&id=2922ed9e&scoped=true"
import script from "./MobileSubscriptions.vue?vue&type=script&charset=utf-8&lang=js"
export * from "./MobileSubscriptions.vue?vue&type=script&charset=utf-8&lang=js"
import style0 from "./MobileSubscriptions.vue?vue&type=style&index=0&id=2922ed9e&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2922ed9e",
  null
  
)

export default component.exports